export default "__VITE_ASSET__D5R4Q6p8__"